module.exports = __webpack_public_path__ + "linea-basic-10.ce776cff0588d8e8385c.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-basic-10.svg
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-basic-10.svg
// module chunks = styles